module.exports = __webpack_public_path__ + "img/_gallery03.c775fc57.jpg";